import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Leistungen from "@/pages/Leistungen";
import ServiceDetail from "@/pages/ServiceDetail";
import Referenzen from "@/pages/Referenzen";
import Kontakt from "@/pages/Kontakt";
import ReferenzDetail from "@/pages/ReferenzDetail";
import { Toaster } from "@/components/ui/sonner";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 0.9, smoothWheel: true, wheelMultiplier: 0.9, touchMultiplier: 1.5 });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <BrowserRouter>
      <ScrollManager />
      <div className="min-h-screen bg-white text-[#0A111E] antialiased">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/leistungen" element={<Leistungen />} />
          <Route path="/leistungen/:slug" element={<ServiceDetail />} />
          <Route path="/referenzen" element={<Referenzen />} />
          <Route path="/referenzen/:slug" element={<ReferenzDetail />} />
          <Route path="/kontakt" element={<Kontakt />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </BrowserRouter>
  );
}
